import React, { ReactElement, useEffect, useState } from 'react';
import { CompleteUserInfoDto } from '../../api/UserOnCreation';
import { GraphClient } from '../../api/MSGraphExtensions';
import { Box, Chip, Typography } from '@mui/material';

type SiteOwnerDetailsProps = {
    siteOwnerId: string;
    selected?: boolean;
    handleClickOwner?(): void;
};

export default function SiteOwnerDetails(props: SiteOwnerDetailsProps): ReactElement {
    const { siteOwnerId, selected, handleClickOwner } = props;

    const [owner, setOwner] = useState<CompleteUserInfoDto | undefined>(undefined);

    useEffect(() => {
        if (!!siteOwnerId) {
            GraphClient.getUserCompleteInfo(siteOwnerId).then((res) => setOwner(res));
        }
    }, [siteOwnerId]);

    return !handleClickOwner ? (
        <div style={{ margin: 10 }}>
            <Chip
                sx={{
                    height: 'auto',
                    p: 1,
                }}
                color={'default'}
                variant="outlined"
                label={
                    <div>
                        <Typography>{owner?.displayName}</Typography>
                    </div>
                }
            />
        </div>
    ) : (
        <div onClick={() => handleClickOwner()} style={{ cursor: 'pointer' }}>
            <Chip
                sx={{
                    height: 'auto',
                    p: 1,
                    cursor: !!handleClickOwner ? 'pointer' : 'auto',
                }}
                color={!!handleClickOwner ? 'primary' : 'default'}
                variant={selected ? 'filled' : 'outlined'}
                label={
                    <div>
                        <Typography>{owner?.displayName}</Typography>
                    </div>
                }
            />
        </div>
    );
}
